angular.module('CarsSaraBo').directive('saraCard', function () {
	return {
		restrict: 'E',
		controller: [SaraCardController],
		controllerAs: 'ctrl',
		bindToController: {
			messages: '=',
		},
		transclude: true,
		templateUrl: 'templates/commons/form/card/card.component.html',
		scope: {} // isolated scope
	};
});

function SaraCardController() {
	var vm = this;
}


//////////////////
// WEBPACK FOOTER
// ./public/app/commons/form/card/card.component.js
// module id = 928
// module chunks = 3